<template>
  <div id="form-cashout">
    <b-card>
      <b-row class=" mb-2">
        <b-col md="12">
          <h3>{{ $route.name }}</h3>
          <b-breadcrumb>
            <b-breadcrumb-item
              ><router-link to="/dashboard">Dashboard</router-link></b-breadcrumb-item
            >
            <b-breadcrumb-item
              ><router-link to="/accounting/cash-transfer">Cash Transfer</router-link></b-breadcrumb-item
            >
            <b-breadcrumb-item active>{{ $route.name }}</b-breadcrumb-item>
          </b-breadcrumb>
          <div class="border-bottom"></div>
        </b-col>
      </b-row>

      <form v-on:submit.prevent="postCashIn()">
      <b-row>
        <b-col md="3">
            <label class="labels">transaction number *</label>
          <div >
            <b-form-input v-model="model.cashNumber" placeholder="no transaction"></b-form-input>
          </div>
        </b-col>
        <b-col md="1"></b-col>
        <b-col md="3">
          <div class="form-group" v-bind:class="errors.has('journalAccountDebit') ? 'has-error':''" >
            <label class="labels">from account</label>
            <b-form-select class="form-control" v-bind:class="errors.has('journalAccountDebit') ? 'is-invalid':''" data-vv-as="journalAccountDebit" name="journalAccountDebit" :options="isBankAccount" v-model="model.journalAccountDebit" /> 
            <p v-if="errors.has('journalAccountDebit') !== null"></p>
          </div>
        </b-col>
        <b-col md="3">
            <label>Account Balance</label>
            <money class="text-right text-bold text-danger text-2xl form-control" v-model="model.journalAccountBalanceNow" readonly placeholder="Debit"/>
        </b-col>
      </b-row>
      <b-row class="mt-3">
        <b-col md="3">
        <div>
          <label class="labels">date*</label>
          <div class="form-group" v-bind:class="errors.has('cashDate') ? 'has-error':''">
          <b-form-datepicker type="date" class="form-control" v-bind:class="errors.has('cashDate') ? 'is-invalid':''" data-vv-as="cashDate"  name="cashDate" v-model="model.cashDate" v-validate="'required'" />
            <p v-if="errors.has('cashDate') !== null"></p>
          </div>
        </div>
        </b-col>
        <b-col md="1"></b-col>
        <b-col md="2">
          <label class="labels">Ammount</label>
           <div class="form-group" v-bind:class="errors.has('idStaff') ? 'has-error':''">
              <money class="text-right form-control"  
              v-bind:class="errors.has('cashTransactionCredit') ? 'is-invalid':''" data-vv-as="cashTransactionCredit" name="cashTransactionCredit"
               v-model="model.cashTransactionCredit"  placeholder="Debit"/>
            <p v-if="errors.has('cashTransactionCredit') !== null"></p>
          </div>
        </b-col>
        <b-col md="1"></b-col>
        
      </b-row>
      <b-row class="mt-2">
        <b-col md="3"></b-col>
        <b-col md="1"></b-col>
      </b-row>
      <b-row>
        <b-col md="4" lg="3">
          <label for="" class="labels">transfer to</label>
          <div>
           <v-select
              id="mySelect"
              label="text"
              v-model="item.journalAccount"
              :options="dataAccountName"
              :reduce="(text) => text.value"
              placeholder="select journal account"
            >
              <template #search="{attributes, events}">
                <input
                  class="vs__search"
                  :required="!item.journalAccount"
                  v-bind="attributes"
                  v-on="events"
                />
              </template>
             </v-select>
          </div>
        </b-col>
        <b-col md="1"></b-col>
        <b-col md="4"></b-col>
      </b-row>
      <b-row class="mt-3">
        <b-col md="4">
          <label for="" class="labels">Description</label>
          <b-form-textarea  v-model="model.cashNote" placeholder="Description"/>
        </b-col>
      </b-row>
      <b-row class="mt-5 mb-4 pb-2">
              <b-col md="6">
                <b-button variant="secondary" class="btn-back float-left" @click="goBack()"
                  ><font-awesome-icon icon="chevron-circle-left"></font-awesome-icon> Back</b-button
                >
              </b-col>
              <b-col md="6">
                <div v-if="loadingButton" class="float-right">
                  <b-button variant="warning" disabled>
                    <b-spinner small type="grow"></b-spinner>
                    Loading...
                  </b-button>
                </div>
                <div v-else>
                  <b-button
                    variant="primary"
                    class="btn-back float-right"
                    type="submit"
                    ><font-awesome-icon icon="save"></font-awesome-icon>
                    Save
                  </b-button>
                </div>
              </b-col>
            </b-row>
      </form>
    </b-card>
  </div>
</template>
<script>
import {Money} from 'v-money'
import Vue from 'vue';
import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';
Vue.use(vSelect, 'v-select');

export default {
  components: { Money },
  data() {
    return {
      loadingButton: false,
      i: 1,
      accountName: '',
      details: '',
      totalCash: 0,
      totalCashIn: 0,
      cashDataObject: [],
      isBankAccount: [],
      dataAccountName: [],
      model: {
        journalAccountDebit: null,
        cashTransactionCredit: 0,
        cashNumber: '',
        cashNote: '',
        cashDate: '',
        cashType: 'CT',
        cashTransaction: [],
        journalAccountBalanceNow: 0
      },
      cashTransactionDebit: [],
      cashTransactionCredit: [],
      dataCreditCash: [],
      dataDebitCash: [],
      cashInData: [],

      apiUrl: {
        cashTransfer: window.AppConfig.apiUrl + 'cash',
        journal: window.AppConfig.apiUrl + 'journal-account'
      },

      item : {
        journalAccount: null,
        details :'',
        totalCashDebit: 0,
        totalCashCredit:0
      },

        //formatter curency
      money: {
          thousands: '.',
          prefix: '',
          suffix: '',
          precision: 0,
          masked: false
        },
    }
  },

   computed: {
    disable() {
      if (this.cashDataObject.length !== 0) {
        return true;
      }
      return false;
    },
  },

  watch: {
   'model.journalAccountDebit'(value){
     this.getBalanceAccount(value)
   }
  },

  mounted() {
    this.getJournalAccount()
    this.getJournal()
    this.initBalance()
  },

  methods: { 
    /**
     * method POST untuk kirim data ke server
     * 
     */
    postCashIn(){
          this.loadingButton = true
          const cashCredit = this.model.cashTransactionCredit
          //same with cash credit
          const cashDebit = this.model.cashTransactionCredit
          this.dataCreditCash.push({
            uuid:"",
           journalAccount: this.model.journalAccountDebit,
            cashTransactionNote: this.model.cashNote,
            cashTransactionDebit: 0,
            cashTransactionCredit:cashCredit,
            delete: 0
          })
         this.dataDebitCash.push({
           uuid: '',
           journalAccount: this.item.journalAccount,
            cashTransactionDebit: cashDebit,
            cashTransactionCredit: 0,
            cashTransactionNote:this.item.details,
          })          
            let formData = new FormData()
            formData.append('cashNumber', this.model.cashNumber)
            formData.append('cashNote', this.model.cashNote)
            formData.append('cashType', this.model.cashType)
            formData.append('cashDate', this.model.cashDate)
            formData.append('cashTransactionDebit', JSON.stringify(this.dataDebitCash))
            formData.append('cashTransactionCredit', JSON.stringify(this.dataCreditCash))
            this.$http.post(this.apiUrl.cashTransfer, formData).then((response) => {
            this.$store.dispatch("notification/success", "Cash Transfer data has been Added")
            window.location.href = document.URL.replace('/create', '/' + response.data.uuid);
              setTimeout(() => {
                this.loadingButton = false
              }, 1000)
            }).catch(error => {
                this.$store.dispatch("notification/error", error)
                this.loadingButton = false
                this.clearDataModel()
            }      
            )
    },

     initBalance(){
      if(this.model.journalAccountDebit !== null){
        this.getBalanceAccount()
      }
    },

     getBalanceAccount(journalUuid) {
      this.$http.get(this.apiUrl.journal + '/'+ journalUuid).then(resp =>{
        this.model.journalAccountBalanceNow = resp.data.journalAccountBalanceNow
      })
    },

    /**
     * Ambil journal akun dari server berdasarkan type bank
     */
    getJournalAccount(){
      this.$http.get(this.apiUrl.journal + '?journalAccountType=D&isBank=1')
      .then((response) => {
        this.isBankAccount = [ {
          value: null,
          text: 'Select Journal Account'
        }]
        response.data._embedded.journal_account.forEach( b => {
          this.isBankAccount.push({
            value: b.uuid,
            text: b.journalAccountCode + ' ' + b.journalAccountName
          })
        })
      })
      .catch(error => {console.log(error);})
    },

    /**
     * Ambil data dari journal dari server
     */
     getJournal(){
      this.$http.get(this.apiUrl.journal)
      .then((response) => {
        response.data._embedded.journal_account.forEach( b => {
          this.dataAccountName.push({
            value: b.uuid,
            text: b.journalAccountCode + ' ' + b.journalAccountName
          })
        })
      })
      .catch(error => {console.log(error);})
    },

    /**
     * hapus row dari table berdasarkan index
     */
    deleteRow(i){
      this.cashDataObject.splice(i, 1)
    },

    /**
     * clear model
     */

    clearDataModel(){
      this.dataCreditCash = [],
      this.dataDebitCash = [],
      this.model.cashNumber = '',
      this.model.cashNote = '',
      this.item.journalAccount = [],
      this.item.totalCashDebit = 0,
      this.item.totalCashCredit = 0
    },

  /**
   * formatter currency untuk data static
   */
   formatNumber(value) {
      let val = (value / 1).toFixed(2).replace(',', '.');
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    },
  }
  
}
</script>

<style>

</style>